<!-- Broadband label for tablet start -->
<div class="main-broadband-section" *ngIf="labelResponse?.length && !isGrandFatheredLabel">
    <div class="broadband-desktop-view">
        <xm-fcc-card page="line-details-cbm">
            <xm-broadband-header [cbmLabelContent]="cbmLabelContent"></xm-broadband-header>
            <div class="broadband-mobile-view">
                <button *ngFor="let item of availableTabs" class="fcc-tab-label column-{{labelResponse?.length}}" [ngClass]="{ 'active': activeTabPlanId === item?.planId }" (click)="tabChange(item?.planId)">{{ item?.name }}</button>
            </div>
            <cbm-nutrition-label
                class="fcc-label column-{{labelResponse?.length}}"
                *ngFor="let label of labelResponse"
                [ngClass]="{ 'active-label': activeTabPlanId === label?.planId }"
                [isInUse]="activePlanId === label?.planId"
                [response]="label"
                [isLineDetailsBBL]="true">
            </cbm-nutrition-label>
        </xm-fcc-card>
    </div>
</div>
<!-- Broadband banner for Grand father for tablet start -->
<div class="header-section" *ngIf="isGrandFatheredLabel">
    <xm-broadband-header [cbmLabelContent]="cbmLabelContent" [isGrandFatheredLabel]="isGrandFatheredLabel" [infoIconGrey]="infoIconGrey"></xm-broadband-header>
</div>
<!-- Broadband banner for Grand father for tablet end -->
 